module.exports = __webpack_public_path__ + "img/103.a7e22f7.svg";